namespace $.$$ {

	$mol_style_define( $shm_hitalama_agent_map_widget_session, {

		flex: {
			grow: 1,
			shrink: 1,
			basis: 0,
		},
		width: '100%',
		height: '100%',
		minWidth: 0,
		minHeight: 0,

		Chat_page: {
			minWidth: 0,
			flex: {
				basis: 0,
			},
		},

		Messages_box: {
			minHeight: 0,
		},

		Prompt: {
			width: '100%',
		},

	} )

}
